import { render } from "./pageTrainCourse.vue?vue&type=template&id=74d25378&scoped=true"
import script from "./pageTrainCourse.vue?vue&type=script&lang=js"
export * from "./pageTrainCourse.vue?vue&type=script&lang=js"

import "./pageTrainCourse.vue?vue&type=style&index=0&id=74d25378&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d25378"]])

export default __exports__